export const STANDARD_TIMESTAMP_FORMAT = 'YYYY-MM-DD hh:mm a z';
export const STANDARD_TIMESTAMP_FORMAT_NO_OFFSET = 'YYYY-MM-DD hh:mm a';
export const TIME_ONLY_FORMAT = 'hh:mm a';
